import axios from 'axios'

import {Api} from '@settings/api'

type DistributedCacheResponse = {keyIdentifier: string; value?: string}

export const GET_SAMPLING_POINTS_PINNED_SECTION_KEY = 'samplingPointsPinnedSection'

export async function getSamplingPointsPinnedSection(
  keyIdentifier: string
): Promise<DistributedCacheResponse> {
  try {
    const path = '/distributeduserstorage'
    const response = await Api.axiosInstance.get<DistributedCacheResponse>(path, {
      params: {keyIdentifier}
    })
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return {keyIdentifier}
    }

    throw error
  }
}
